import { useState } from "react";
import useContext from "../../../context";
import { getEmailQuoteUrl, getLoadingImageUrl } from "../../../config";

const dollars = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

export default function EmailQuoteModal({ open, setOpen }) {
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');

  const [context] = useContext();

  const submitEmail = async () => {
    setError('');
    setLoading(true);

    const data = new FormData();
    const isRefinance = context.contractType === 'refinance';

    const creditCheckLoan = context.response.creditCheck;
    const noCreditCheckLoan = context.response.noCreditCheck;

    const buildCostItems = (loan) => [
      {
        label: isRefinance ? 'Estimated Proceeds after Closing' : 'Estimated Cash to Close',
        value: dollars.format(isRefinance ? loan.estimated_proceeds : loan.estimated_cash_to_close),
      },
      {
        label: 'Total Loan Amount',
        value: dollars.format(loan.total_loan_amount),  
      },
      {
        label: 'Loan Term',
        value: `${loan.loan_term} years`,
      },
      {
        label: 'Interest Rate',
        value: `${loan.interest_rate}%`,
      },
      {
        label: 'Estimated Monthly Payment',
        value: `${dollars.format(loan.monthly_payment)}/mo.`,
      },
    ];


    data.append('email', email);
		data.append( 'api_key', '7FAjiWpBYTwlMkqUhuKP1X');
		data.append( 'contract', context.contractType);
		data.append( 'resort', context.resort);
		data.append( 'total_points', context.totalPoints);
		data.append( 'credit_rating', context.creditRating);
		data.append( 'term', context.term);
		data.append( 'cost_items', JSON.stringify({ credit_check: buildCostItems(creditCheckLoan), no_credit_check: buildCostItems(noCreditCheckLoan) } ) );

    if (!isRefinance) {
      const options = context.response.noCreditCheck.down_payment_options || [500, 1000, 2000];

      data.append( 'price_per_point', context.pricePerPoint);
      data.append( 'down_payment', options[context.downPaymentOption - 1]);
    } else {
      const options = context.response.noCreditCheck.refinance_options || [];

      data.append( 'refi_amount', options[context.downPaymentOption - 1]);
    }

    const resp = await fetch(getEmailQuoteUrl(), {
      method: 'POST',
      body: data,
    });

    if (resp.status >= 400) {
      setError('There was an error sending your email. Please try again later.');
      setLoading(false);
    } else {
      const data = await resp.json();

      if (!data.sent) {
        setError('There was an error sending your email. Please try again later.');
        setLoading(false);
      } else {
        setSent(true);
        setLoading(false);
      }
    }
  }

  return (
    <div className={`emailModal ${!open ? '-isClosed' : ''} ${error ? '-isError' : ''}`}>
      <div className="emailModal__inside">
        <button className="emailModal__close" onClick={()=> setOpen(false)}><i className="fa fa-multiply"/></button>
        <div className="emaiModal__body">
          <h2 className="emailModal__title">{ !sent ? 'Get an Email Quote' : 'Thank You' }</h2>
          <p className={`emailModal__text ${ sent ? '-isThankYou' :'' }`}>
            { !sent ?
              'Provide your email address in the field below and we’ll send your quote straight to your inbox. From there, you can review all the details at your leisure and return to the application process whenever you’re ready!' : 
              'The information you requested is on its way and should arrive to your inbox soon.'
            }
          </p>
          { !sent && !loading && (
            <div className="emailModal__form">
              <input className="emailModal__input" placeholder="Email Address" type="email" value={email} onChange={({ target: { value } }) => setEmail(value)} />
              {
                error && (
                  <div className="emailModal__error">{error}</div>
                )
              }
              <button className="btn emailModal__button" onClick={submitEmail}><span>Send</span></button>
            </div>
          )}
          {
            loading && getLoadingImageUrl() && (
              <div className="emailModal__processing">
                <img src={getLoadingImageUrl()} alt="" />
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanCards/components/EmailQuoteModal.js